import React, { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
  DialogDescription,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Textarea } from '@/components/ui/textarea'
import { Label } from '@/components/ui/label'

const TimerStopDialog = ({ open, onOpenChange, elapsedLabel, taskTitle, onConfirm, loading }) => {
  const [note, setNote] = useState('')

  const handleConfirm = () => {
    onConfirm(note.trim() || null)
    setNote('')
  }

  const handleCancel = () => {
    onOpenChange(false)
    setNote('')
  }

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) handleCancel() }}>
      <DialogContent className="sm:max-w-[400px]">
        <DialogHeader>
          <DialogTitle>Stop Timer</DialogTitle>
          <DialogDescription>
            Stop timer for <strong>{taskTitle}</strong> — {elapsedLabel} elapsed
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3 py-2">
          <div className="space-y-1.5">
            <Label htmlFor="note">Note (optional)</Label>
            <Textarea
              id="note"
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="What did you work on?"
              rows={3}
              autoFocus
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={handleCancel} disabled={loading}>Cancel</Button>
          <Button onClick={handleConfirm} disabled={loading}>
            {loading ? 'Stopping...' : 'Stop Timer'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default TimerStopDialog
